import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './styles/index.css'
import { initSentry, captureException } from '@/config/sentry'
import { initGtm } from '@/config/gtm'

// Initialize Sentry before React renders
initSentry()

// Bootstrap Google Tag Manager so customer-deployed tags (including the
// Ricald pixel published via Settings → Integrations → Install Pixel)
// actually fire. No-op when VITE_GTM_CONTAINER_ID is unset.
initGtm()

// Global error handler for uncaught errors
window.onerror = (message, source, lineno, colno, error) => {
  captureException(error || new Error(String(message)), {
    source,
    lineno,
    colno,
  })
}

// Global handler for unhandled promise rejections
window.onunhandledrejection = (event: PromiseRejectionEvent) => {
  captureException(event.reason, {
    type: 'unhandledrejection',
  })
}

ReactDOM.createRoot(
  document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
